import getProperty from 'lodash-es/get';
import {i18n} from 'mc/lib';
import {FeatureEditor, FeatureEditorActions} from 'mc/lib/mapio';
import {ModalActions} from 'mc/lib/modal';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {Card, CardText, CardTitle, Col, FormGroup, Label, Row} from 'reactstrap';
import {CurrentZadostActions} from '../../actions';
import {Api} from '../../api';
import {TypUcel} from '../../enums';
import {getOuterHeight} from '../../utils';
import {Loading} from '../common';
import {
    createFeatureFilterFromLokalitaList as createFeatureFilter,
    getFeaturesFromLokalitaList as getFeatures,
    LokalitaForm,
    LokalitaList,
} from '../lokalita';
import {formatSubjekt} from '../subjekt';
import ZadostBackButton from './ZadostBackButton';
import ZadostFooter from './ZadostFooter';
import ZadostLayout from './ZadostLayout';
import ZadostNextButton from './ZadostNextButton';

const featureEditorArea = 'zadostZakresFeatureEditor';
const featureEditorColor = [233, 47, 102];

function getFeatureEditorHeight() {
    if (window.innerWidth < 768) {
        return 500;
    }

    const header = document.getElementById('header');
    const stage = document.getElementById('stage');
    const heading = document.getElementById('heading');
    const footer = document.getElementById('footer');

    const headerHeight = header ? getOuterHeight(header) : 50;
    const stageHeight = stage ? getOuterHeight(stage) : 40;
    const headingHeight = heading ? getOuterHeight(heading) : 70;
    const footerHeight = footer ? getOuterHeight(footer) : 50;

    return window.innerHeight - headerHeight - stageHeight - headingHeight - footerHeight - 15;
}

class ZadostZakres extends PureComponent {

    static propTypes = {
        zadost: PropTypes.object,
        dispatch: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.handlePropsChange(props, null);
    }

    componentDidMount() {
        const {params, dispatch} = this.props;
        const {id} = params;

        if (isNaN(id)) {
            browserHistory.push(serverContextPath);
        } else {
            this.featureEditorStyle = {height: getFeatureEditorHeight() + 'px'};
            dispatch(CurrentZadostActions.fetchIfNeeded(id, false, true, true));
        }
    }

    componentDidUpdate(prevProps) {
        this.handlePropsChange(this.props, prevProps);
    }

    handlePropsChange(newProps, oldProps) {
        const newLokalitaList = getProperty(newProps, 'zadost.lokalitaList');
        const oldLokalitaList = getProperty(oldProps, 'zadost.lokalitaList');

        if (newLokalitaList && newLokalitaList !== oldLokalitaList) {
            newProps.dispatch(FeatureEditorActions.loadFeatures(featureEditorArea, getFeatures(newLokalitaList)));
        }
    }

    handleAddLokalita = typUcel => {
        this.showLokalitaForm(typUcel, {
            zakresZTextu: false,
            identifikaceUpravenaRucne: false,
            geodata: [],
            obdobiList: [],
            dokumentList: [],
        });
    };

    handleEditLokalita = lokalita => {
        this.showLokalitaForm(lokalita.druhUcel.typUcel, lokalita);
    };

    handleDeleteLokalita = lokalita => {
        const {zadost, dispatch} = this.props;

        Api.deleteLokalita(zadost.id, lokalita.id).then(() => {
            dispatch(CurrentZadostActions.deleteLokalita(zadost.id, lokalita.id));
        });
    };

    showLokalitaForm(typUcel, initialValues) {
        const {dispatch, zadost} = this.props;
        const {typZabor: {druhUcelList}} = zadost;

        const formProps = {
            druhUcelList: druhUcelList.filter(druhUcel => druhUcel.typUcel === typUcel),
            initialValues,
            onSubmit: newLokalita => {
                return this.saveLokalita(newLokalita);
            },
            onSubmitSuccess: savedLokalita => {
                dispatch(CurrentZadostActions.setLokalita(zadost.id, savedLokalita));
                dispatch(ModalActions.hide());
            },
            onCancel: () => {
                dispatch(ModalActions.hide());
            },
        };

        dispatch(ModalActions.show(LokalitaForm, formProps, TypUcel.getCaption(typUcel), {size: 'full'}));
    }

    saveLokalita(newLokalita) {
        const dokumentList = newLokalita.dokumentList.filter(dokument => dokument.id); // Již uložené dokumenty
        const souborList = newLokalita.dokumentList.map(dokument => dokument.soubor).filter(Boolean); // Soubory nových dokumentů

        const lokalitaToSave = {...newLokalita, dokumentList}; // Necháme pouze již uložené dokumenty
        const saveCallback = newLokalita.id ? Api.updateLokalita : Api.createLokalita;
        const {zadost} = this.props;

        return saveCallback(zadost.id, lokalitaToSave).then(savedLokalita => {
            if (souborList.length === 0) {
                return savedLokalita;
            }
            return Api.createLokalitaDokumenty(zadost.id, savedLokalita.id, souborList).then(savedDokumentList => {
                const dokumentList = [...savedLokalita.dokumentList, ...savedDokumentList];
                return {...savedLokalita, dokumentList}; // Přidáme nově uložené dokumenty
            });
        });
    }

    render() {
        const {zadost} = this.props;
        if (zadost == null) {
            return <Loading block="full"/>;
        }

        const {typZabor, zadatel, lokalitaList} = zadost;
        const {druhUcelList} = typZabor;

        return (
            <ZadostLayout className="zadost-zakres" stage={3}>
                <h1 id="heading">{i18n('zadostZakres.title')}</h1>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <Card block>
                            <CardTitle>{typZabor.nazev}</CardTitle>
                            <CardText tag="div">
                                <FormGroup>
                                    <Label>{i18n('zadostZakres.applicant')}</Label>
                                    <div>{zadatel
                                        ? formatSubjekt(zadatel)
                                        : <p className="text-danger">{i18n('zadostZakres.noApplicant')}</p>}
                                    </div>
                                </FormGroup>
                            </CardText>
                        </Card>
                        <LokalitaList druhUcelList={druhUcelList}
                                      lokalitaList={lokalitaList}
                                      onAdd={this.handleAddLokalita}
                                      onEdit={this.handleEditLokalita}
                                      onDelete={this.handleDeleteLokalita}/>
                    </Col>
                    <Col xs={12} md={6} lg={8} className="mt-3 mt-md-0">
                        <FeatureEditor area={featureEditorArea}
                                       filter={createFeatureFilter(lokalitaList)}
                                       color={featureEditorColor}
                                       style={this.featureEditorStyle}
                                       readOnly/>
                    </Col>
                </Row>
                <ZadostFooter>
                    <ZadostBackButton path={`/zadost/${zadost.id}/nalezitosti`}/>
                    <ZadostNextButton path={`/zadost/${zadost.id}/shrnuti`} disabled={!zadatel || !lokalitaList.length}/>
                </ZadostFooter>
            </ZadostLayout>
        );
    }

}

const mapStateToProps = state => {
    // Musíme kontrolovat načtení seznamu lokalit, může probíhat přenačtení již načtené žádosti
    const {data, isFetching, fetched} = state.app.currentZadost;
    const isFetched = !isFetching && fetched && data && data.lokalitaList;
    return {
        zadost: isFetched ? data : null,
    };
};

export default connect(mapStateToProps)(ZadostZakres);
